export const normalizeProductName = value => value.normalize('NFD').replace(/[\u0300-\u036f]/g, '').replace(/^\s*\d+\s*#\s*/, '').trim().toLowerCase().replace(/\s+/g, ' ');
export function shelvesFor(slots) {
    const groups = new Map();
    for (const row of slots) {
        const key = row.shelf || null;
        if (!groups.has(key)) groups.set(key, []);
        groups.get(key).push(row);
    }
    const widest = Math.max(1, ...[...groups.values()].map(rows => rows.length));
    return [...groups].sort(([a], [b]) => (a || Infinity) - (b || Infinity)).map(([shelf, rows]) => ({
        shelf, columns: widest, span: rows.length * 2 === widest ? 2 : 1, rows: rows.sort((a, b) => a.slotId - b.slotId)
    }));
}
// CSV quoting, commas/newlines inside notes, escaped double quotes and CRLF.
export function readCsv(text) {
    const rows = []; let row = [], field = '', quoted = false, closed = false;
    text = text.replace(/^\uFEFF/, '').replace(/\r\n/g, '\n');
    for (let i = 0; i < text.length; i++) {
        const c = text[i];
        if (quoted) {
            if (c === '"' && text[i + 1] === '"') { field += '"'; i++; }
            else if (c === '"') { quoted = false; closed = true; }
            else field += c;
        } else if (c === '"' && !field && !closed) quoted = true;
        else if (c === ',' || c === '\n') {
            row.push(field); field = ''; closed = false;
            if (c === '\n') { if (row.some(v => v.trim())) rows.push(row); row = []; }
        } else if (closed || c === '"') throw new Error('CSV inválido: revisa las comillas.');
        else field += c;
    }
    if (quoted) throw new Error('CSV inválido: comillas sin cerrar.');
    row.push(field); if (row.some(v => v.trim())) rows.push(row);
    return rows;
}
export function previewTemplateCsv(text, products) {
    const [header, ...rows] = readCsv(text);
    const required = ['carril', 'estante', 'capacidad', 'producto', 'precio_maquina', 'nota'];
    if (!header || header.length !== required.length || new Set(header.map(v => v.trim())).size !== required.length || required.some(k => !header.map(v => v.trim()).includes(k))) throw new Error(`Columnas requeridas: ${required.join(', ')}.`);
    if (!rows.length || rows.length > 500) throw new Error('El CSV debe tener entre 1 y 500 posiciones.');
    const ids = new Set(), active = products.filter(p => p.active);
    return rows.map((cells, index) => {
        if (cells.length !== header.length) throw new Error(`Fila ${index + 2}: número de columnas incorrecto.`);
        const r = Object.fromEntries(header.map((k, i) => [k.trim(), cells[i].trim()]));
        const integer = (s, min) => /^\d+$/.test(s) && Number.isSafeInteger(Number(s)) && Number(s) >= min;
        if (!integer(r.carril, 1) || !integer(r.estante, 1) || !integer(r.capacidad, 0) || ids.has(Number(r.carril))) throw new Error(`Fila ${index + 2}: carril, estante o capacidad inválidos, o carril duplicado.`);
        if (r.precio_maquina && !/^\d+(\.\d{1,2})?$/.test(r.precio_maquina)) throw new Error(`Fila ${index + 2}: precio inválido.`);
        if (r.nota.length > 2000) throw new Error(`Fila ${index + 2}: nota demasiado larga.`);
        ids.add(Number(r.carril));
        const name = normalizeProductName(r.producto), matches = active.filter(p => normalizeProductName(p.name) === name);
        const words = name.split(/\W+/).filter(w => w.length > 2);
        const candidates = name ? active.map(p => ({ ...p, score: words.filter(w => normalizeProductName(p.name).includes(w)).length / Math.max(1, words.length) })).filter(p => p.score >= 0.5).sort((a, b) => b.score - a.score).slice(0, 3) : [];
        const price = r.precio_maquina ? Math.round(Number(r.precio_maquina) * 100) : null;
        if (price !== null && !Number.isSafeInteger(price)) throw new Error(`Fila ${index + 2}: precio fuera de rango.`);
        return { slotId: Number(r.carril), shelf: Number(r.estante), capacity: Number(r.capacidad), notes: r.nota,
            suggestedPriceCents: price, productId: matches.length === 1 ? matches[0]._id : null, proposedName: r.producto,
            match: !name ? 'Sin asignar' : matches.length === 1 ? 'Exacto' : matches.length > 1 ? 'Ambiguo' : candidates.length ? 'Aproximado' : 'No encontrado',
            candidates: matches.length ? matches : candidates };
    }).sort((a, b) => a.slotId - b.slotId);
}
export function templatePayload(template, slots) {
    return { name: template.name, active: template.active, verificationPending: Boolean(template.verificationPending),
        ...(template.updatedAt ? { expectedUpdatedAt: template.updatedAt } : {}),
        slots: slots.map(r => ({ slotId: r.slotId, shelf: r.shelf || null, capacity: r.capacity, notes: r.notes || '', productId: r.productId || null, suggestedPriceCents: r.suggestedPriceCents ?? null })) };
}
